import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

let   partnersBlock  = document.querySelectorAll('.block.partners');
let   partnersSwiper = {};

if ( partnersBlock ) {
  Array.from( partnersBlock ).forEach( (block) => {
    partnersSwiper[block.dataset.id] = new Swiper(
      block.querySelector('.swiper'),
      {
        slidesPerView: 3,
        loop: true,
        navigation: {
          prevEl: block.querySelector('.button--prev'),
          nextEl: block.querySelector('.button--next')
        },
        breakpoints: {
          375: {
            slidesPerView: 2,
            centeredSlides: true,
            spaceBetween: 36,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 50,
            centeredSlides: false
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 150,
            centeredSlides: false
          }
        }
      }
    );
  } );
}

